module.exports = __webpack_public_path__ + "media/tip.7068643e.wav";